/**
 * Where ungraded play picks up when the player taps "Still playing?" after the
 * 30-minute no-interaction pause.
 *
 * Intended behaviour:
 * - Repertoire: jump back one bar (the count-in length) and count in; less
 *   than a bar into the piece, start from the beginning.
 * - Sight reading: restart the current phrase with the count-in.
 *
 * Both need the 1-bar count-in for ungraded play, which comes with the count-in
 * engine. Until that lands, play resumes where it paused.
 *
 * TODO(count-in): when the count-in engine is in, route each surface's resume
 * through it here (jump back and count in), so both call sites stay as they are.
 */
export type IdleResumeSurface = 'sight-reading' | 'repertoire';

export const resumeAfterIdlePause = (_surface: IdleResumeSurface, resumePlay: () => void): void => {
  resumePlay();
};
